import { Host, h } from "@stencil/core";
import { focusComposedPath } from "../common/helpers";
const mapTooltipAlignToChWindowAlign = {
    OutsideStart: "outside-start",
    InsideStart: "inside-start",
    Center: "center",
    InsideEnd: "inside-end",
    OutsideEnd: "outside-end"
};
const EXPORT_PARTS = "window:section,mask";
export class ChTooltip {
    constructor() {
        this.hidden = true;
        this.tooltipId = "Tooltip";
        this.delay = 100;
        this.position = "OutsideStart_Center";
    }
    /** The container element for ch-window.
     */
    container;
    showWithDelay = () => {
        setTimeout(() => {
            this.hidden = false;
        }, this.delay);
    };
    handleEnter = () => {
        if (!this.hidden) {
            return;
        }
        this.showWithDelay();
    };
    handleLeave = () => {
        if (this.container === focusComposedPath()[0]) {
            this.hidden = false;
        }
        this.hidden = true;
    };
    addListeners = () => {
        this.container.addEventListener("focus", this.handleEnter);
        this.container.addEventListener("focusout", this.handleLeave);
        this.container.addEventListener("mouseenter", this.handleEnter);
        this.container.addEventListener("mouseleave", this.handleLeave);
    };
    removeListeners = () => {
        this.container.removeEventListener("focus", this.handleEnter);
        this.container.removeEventListener("focusout", this.handleLeave);
        this.container.removeEventListener("mouseenter", this.handleEnter);
        this.container.removeEventListener("mouseleave", this.handleLeave);
    };
    componentDidLoad() {
        this.container = document.querySelector('[slot="container"] > :first-child');
        this.addListeners();
    }
    disconnectedCallback() {
        this.removeListeners();
    }
    render() {
        const aligns = this.position.split("_");
        const alignX = aligns[0];
        const alignY = aligns[1];
        return (h(Host, null, h("slot", { name: "container" }), h("ch-window", { exportparts: EXPORT_PARTS, "show-header": false, "show-footer": false, modal: false, "close-on-escape": true, hidden: this.hidden, container: this.container, xAlign: mapTooltipAlignToChWindowAlign[alignX], yAlign: mapTooltipAlignToChWindowAlign[alignY] }, h("div", { role: "tooltip", class: "tooltip-content", id: this.tooltipId }, h("slot", { name: "content" })))));
    }
    static get is() { return "ch-tooltip"; }
    static get originalStyleUrls() {
        return {
            "$": ["tooltip.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tooltip.css"]
        };
    }
    static get properties() {
        return {
            "tooltipId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the tooltip description."
                },
                "attribute": "tooltip-id",
                "reflect": false,
                "defaultValue": "\"Tooltip\""
            },
            "delay": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the delay (in ms)\nfor the tooltip to be displayed."
                },
                "attribute": "delay",
                "reflect": false,
                "defaultValue": "100"
            },
            "position": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "| \"OutsideStart_OutsideStart\"\n    | \"InsideStart_OutsideStart\"\n    | \"Center_OutsideStart\"\n    | \"InsideEnd_OutsideStart\"\n    | \"OutsideEnd_OutsideStart\"\n    | \"OutsideStart_InsideStart\"\n    | \"OutsideEnd_InsideStart\"\n    | \"OutsideStart_Center\"\n    | \"OutsideEnd_Center\"\n    | \"OutsideStart_InsideEnd\"\n    | \"OutsideEnd_InsideEnd\"\n    | \"OutsideStart_OutsideEnd\"\n    | \"InsideStart_OutsideEnd\"\n    | \"Center_OutsideEnd\"\n    | \"InsideEnd_OutsideEnd\"\n    | \"OutsideEnd_OutsideEnd\"",
                    "resolved": "\"Center_OutsideEnd\" | \"Center_OutsideStart\" | \"InsideEnd_OutsideEnd\" | \"InsideEnd_OutsideStart\" | \"InsideStart_OutsideEnd\" | \"InsideStart_OutsideStart\" | \"OutsideEnd_Center\" | \"OutsideEnd_InsideEnd\" | \"OutsideEnd_InsideStart\" | \"OutsideEnd_OutsideEnd\" | \"OutsideEnd_OutsideStart\" | \"OutsideStart_Center\" | \"OutsideStart_InsideEnd\" | \"OutsideStart_InsideStart\" | \"OutsideStart_OutsideEnd\" | \"OutsideStart_OutsideStart\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the position of the tooltip relative to\nthe container element."
                },
                "attribute": "position",
                "reflect": false,
                "defaultValue": "\"OutsideStart_Center\""
            }
        };
    }
    static get states() {
        return {
            "hidden": {}
        };
    }
}
//# sourceMappingURL=tooltip.js.map
